/**
 * matches URL's like `https://sd-aabbcc00.stardog.cloud:5820`
 */
export const isUrlStardogFreeCloudInstance = (urlString: string) => {
  try {
    const url = new URL(urlString);
    return (
      url.hostname.startsWith('sd-') && url.hostname.endsWith('.stardog.cloud')
    );
  } catch {
    return false;
  }
};
